import { Toast } from 'vant';
import { resInterceptors, reqInterceptors, resErrInterceptors} from './interceptors';
import axios from 'axios';
import store from '../store/index.js'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分 生成环境"/prod-api/",
  baseURL: "/dev-api/",
  timeout: 50000,
});
service.interceptors.request.use(
  config => {
    const isToken = (config.headers || {}).isToken === false
      const stoken = localStorage.getItem('Token');
      const token = store.getters && store.getters.token;
      const realtoken = token || stoken;
    if (realtoken && !isToken) {

      config.headers['Authorization'] = 'Bearer ' + realtoken
    } // 让每个请求携带自定义token 请根据实际情况自行修改
    return reqInterceptors(config) ;
  },
  error => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      Toast.clear()
      return resInterceptors(response)
    }else {
      return Promise.reject()
    }
  },
  error => {
    console.log(error);
    return resErrInterceptors(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/service.js